import React from 'react';
import styled from '@emotion/styled';
import { IDeveloper } from 'utils/entities';
import { SmallText, Text } from 'ds/components/typography';

const Divider = styled(Text)`
  margin: 0 ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;

const DevelopersWrapper = styled.div<{ maxWidth?: number; isCentered?: boolean }>`
  display: flex;
  align-items: center;
  overflow: hidden;
  width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : 'auto')};
  margin: 0 ${({ maxWidth, isCentered }) => (maxWidth && isCentered ? 'auto' : '0')};
`;

const DeveloperNameWrapper = styled(SmallText.withComponent('a'))`
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  flex-shrink: 1;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.brand.main};
  text-decoration: none;
`;

interface DevelopersProps {
  developers: IDeveloper[];
  maxWidth?: number;
  isCentered?: boolean;
}

export const Developers: React.FC<DevelopersProps> = ({ developers, maxWidth, isCentered }) => (
  <DevelopersWrapper maxWidth={maxWidth} isCentered={isCentered}>
    {developers.map((developer, idx) => (
      <React.Fragment key={developer.developerLink}>
        {idx === 0 ? null : <Divider>•</Divider>}
        <DeveloperNameWrapper data-auto="developer-link" href={developer.developerLink} target="_blank">
          {developer.name}
        </DeveloperNameWrapper>
      </React.Fragment>
    ))}
  </DevelopersWrapper>
);
